/**
 * 所有企业微信icon授权进入，授权跳转中心
 */

export function getAuthPath(type) {
  switch (type) {
    case 'GROUP_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_BULLETIN_BOARD
    case 'DIVISION_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_DIVISION_BOARD
    case 'STORE_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_STORE_BOARD
    case 'AREA_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_AREA_BOARD
    case 'AREA_CHIEF_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_AREA_CHIEF_BOARD
    case 'SBC_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_SBC_BOARD
    case 'BBC_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_BBC_BOARD
    case 'B2C_BOARD':
      return process.env.VUE_APP_WEIXIN_AUTH_B2C_BOARD
    case 'NORMAL':// 通用的先走集团
    case 'NORMAL_OPERATE':
    default:
      return process.env.VUE_APP_WEIXIN_AUTH_BULLETIN_BOARD
  }
}

export function getPathWithId(label_sign, auth_item) {
  let name = ''
  switch (label_sign) {
    case 'GROUP_BOARD':
      name = 'ProfitBoard'
      break
    case 'DIVISION_BOARD':
      name = 'Division'
      break
    case 'STORE_BOARD':
      name = 'ShopManager'
      break
    case 'AREA_BOARD':
      name = 'AreaBoard'
      break
    case 'AREA_CHIEF_BOARD':
      name = 'ChargeDivision'
      break
    case 'SBC_BOARD':
    case 'BBC_BOARD':
    case 'B2C_BOARD':
      // TODO
      name = 'RankingList'
      break
    case 'NORMAL':
      name = 'Normal'
      break
    case 'NORMAL_OPERATE':
      name = 'IncomeExpense'
      break
    default:
      name = 'NoPower'
      break
  }
  return {
    name: name,
    query: {
      department_id: auth_item.department_id,
      department_name: auth_item.department_name,
      board_auth_label: label_sign,
      type: 'profit',
      tab_visible: '1',
      btn_type: '0'
    },
    replace: true
  }
}

export function getPathManageTab(label_sign, auth_item) {
  if (label_sign) {
    return {
      name: 'ManageTab',
      query: {
        department_id: auth_item.department_id,
        department_name: auth_item.department_name,
        board_auth_label: label_sign,
        type: 'profit',
        tab_visible: '1',
        btn_type: '0'
      },
      replace: true
    }
  }
}

export function getNewPathWithId(label_sign, department_id, department_name) {
  let name = ''
  switch (label_sign) {
    case 'GROUP_BOARD':
      name = 'ProfitBoard'
      break
    case 'DIVISION_BOARD':
      name = 'Division'
      break
    case 'STORE_BOARD':
      name = 'ShopManager'
      break
    case 'AREA_BOARD':
      name = 'AreaBoard'
      break
    case 'AREA_CHIEF_BOARD':
      name = 'ChargeDivision'
      break
    case 'SBC_BOARD':
    case 'BBC_BOARD':
    case 'B2C_BOARD':
      // TODO
      name = 'RankingList'
      break
    case 'NORMAL':
      name = 'Normal'
      break
    case 'NORMAL_OPERATE':
      name = 'IncomeExpense'
      break
    default:
      name = 'NoPower'
      break
  }
  return {
    name: name,
    query: {
      department_id: department_id,
      department_name: department_name,
      board_auth_label: label_sign,
      type: 'profit',
      tab_visible: '0',
      btn_type: '0'
    },
    replace: true
  }
}

